var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhiteLabelLargeMonochrome = function SvgWhiteLabelLargeMonochrome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 335,
    height: 470,
    fill: "none",
    viewBox: "0 0 335 470"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-label-large-monochrome_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#454549",
    strokeWidth: 2,
    d: "M168 49v345m73.245-313.829L94.166 227.25m176.829-73.245h-208m176.829 73.245L92.746 80.171"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 130,
    stroke: "#454549",
    strokeDasharray: "4 4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 153,
    r: 248,
    stroke: "#454549",
    strokeDasharray: "4 4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 22,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.369,
    cy: 60.369,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(-45 75.369 60.369)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.631,
    cy: 245.631,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(-45 260.631 245.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299,
    cy: 153,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(90 299 153)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 153,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(90 37 153)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.631,
    cy: 60.369,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(45 260.631 60.369)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.369,
    cy: 245.631,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2,
    transform: "rotate(45 75.369 245.631)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167,
    cy: 153,
    r: 51,
    fill: "#17161B",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m165.986 129.426-17.919 10.359a3.13 3.13 0 0 0-1.567 2.704v21.022c0 1.114.597 2.144 1.567 2.704l17.919 10.359c.985.57 2.204.568 3.188-.005l17.768-10.352a3.13 3.13 0 0 0 1.558-2.698v-21.037c0-1.11-.593-2.137-1.558-2.699l-17.768-10.352a3.18 3.18 0 0 0-3.188-.005m-.032 9.142-9.825 5.679a3.13 3.13 0 0 0-1.567 2.704v11.571c0 1.113.597 2.143 1.567 2.704l9.825 5.68a3.18 3.18 0 0 0 3.189-.006l9.737-5.673a3.12 3.12 0 0 0 1.557-2.698v-11.585a3.12 3.12 0 0 0-1.557-2.698l-9.737-5.673a3.18 3.18 0 0 0-3.189-.005",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M180.005 160.109a3.1 3.1 0 0 0 .432-1.58v-12.987l7.743-4.433a3.14 3.14 0 0 0-1.238-1.326l-17.768-10.352a3.18 3.18 0 0 0-3.189-.005l-17.919 10.359a3.13 3.13 0 0 0-1.244 1.326l7.74 4.432z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#38383A",
    fillRule: "evenodd",
    d: "M167.5 129.001a3.2 3.2 0 0 0-1.515.425l-17.919 10.359a3.13 3.13 0 0 0-1.244 1.326l7.74 4.431v12.98c0 .567.155 1.113.435 1.585l12.503-7.158z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 284,
    r: 27,
    fill: "#17161B",
    stroke: "#454549",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 394,
    r: 51,
    fill: "#17161B",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m162.79 408.742 1.169 2.629a4.42 4.42 0 0 0 4.044 2.629 4.42 4.42 0 0 0 4.045-2.629l1.169-2.629a4.85 4.85 0 0 1 4.94-2.846l2.86.304a4.43 4.43 0 0 0 4.298-2.189 4.42 4.42 0 0 0-.254-4.815l-1.693-2.327a4.86 4.86 0 0 1-.92-2.869 4.86 4.86 0 0 1 .929-2.858l1.693-2.326a4.42 4.42 0 0 0 .253-4.816 4.42 4.42 0 0 0-4.297-2.189l-2.86.305a4.87 4.87 0 0 1-2.94-.625 4.85 4.85 0 0 1-2-2.233l-1.178-2.629a4.42 4.42 0 0 0-4.045-2.629 4.42 4.42 0 0 0-4.044 2.629l-1.169 2.629a4.85 4.85 0 0 1-2 2.233 4.87 4.87 0 0 1-2.94.625l-2.869-.305a4.43 4.43 0 0 0-4.298 2.189 4.43 4.43 0 0 0 .254 4.816l1.693 2.326a4.86 4.86 0 0 1 0 5.716l-1.693 2.326a4.422 4.422 0 0 0 1.571 6.547 4.44 4.44 0 0 0 2.473.458l2.86-.305a4.87 4.87 0 0 1 2.94.625 4.85 4.85 0 0 1 2.009 2.233"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M168 400a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#454549",
    d: "M8 .5h319a7.5 7.5 0 0 1 7.5 7.5v454a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 462V8l.01-.386A7.5 7.5 0 0 1 8 .5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "white-label-large-monochrome_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8a8 8 0 0 1 8-8h319a8 8 0 0 1 8 8v454a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })))));
};
export default SvgWhiteLabelLargeMonochrome;